import script from "./CartPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPopup.vue?vue&type=script&setup=true&lang=js"

import "./CartPopup.vue?vue&type=style&index=0&id=499d8fe7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-499d8fe7"]])

export default __exports__